import createProjectStore from './createProjectStore'
import { getQueryStringParams } from '@/common/utils/queryStringUtils'
import getEnvVars from '@/common/utils/getEnvVars'

let _store_ = null

export const createStore = () => {
  const { search, pathname } = window.location
  const { API_HOST } = getEnvVars()
  const params = getQueryStringParams(search)
  _store_ = createProjectStore(params, API_HOST, null)
  return _store_
}

export const getStore = () => {
  return _store_ ? _store_ : createStore()
}

const eh = 99

export default eh
